import React from 'react';

import './style.sass';

type Props = {
    className?: string,
    text: string,
};

export const DividerWithText = ({ className, text }: Props) => {
    return (
        <div className={`divider ${className ? className : ''}`}>
            <div className="divider__left"></div>
            <div className="divider__text p2-medium grey-2">{text}</div>
            <div className="divider__right"></div>
        </div>
    );
};
